<template>
  <el-dialog
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      :title="template.id > 0 ? '编辑' : '新建'"
      width="800px"
      top="1vh"
      @close="$reset('form')">
    <el-form
        ref="form"
        v-loading="contentLoading"
        :model="template"
        label-width="auto">
      <div class="title">基础信息</div>
      <el-form-item prop="name" label="模板名称" :rules="$rule.notNull">
        <el-input v-model="template.name" placeholder="请输入模板名称"/>
      </el-form-item>
      <el-form-item prop="typeId" label="模板类型" :rules="$rule.notNull">
        <el-select v-model="template.typeId" :loading="typeLoading" clearable placeholder="请选择">
          <el-option
              v-for="item in templateTypes"
              :key="item.itemId"
              :label="item.itemName"
              :value="item.itemId"/>
        </el-select>
      </el-form-item>
      <el-form-item prop="note" label="备注">
        <el-input
            v-model="template.note"
            placeholder="请输入备注"
            type="textarea"
            autosize
            maxlength="500"
            show-word-limit/>
      </el-form-item>
      <el-form-item label="模板文件">
        <template v-if="template.attachment && template.attachment.fileName">
          <span>{{template.attachment.fileName}}</span>
          <el-button type="text" :loading="downLoadLoading" style="margin-left: 10px" @click="handleDownload">下载</el-button>
          <el-button type="text" style="margin-left: 10px" @click="handleFileDelete">删除</el-button>
        </template>
        <el-upload
            v-else
            action=""
            :http-request="getVoucher"
            :before-upload="beforeUpload"
            :on-error="handlerError"
            :on-success="handleSuccess"
            drag
            :show-file-list="false"
            accept=".jrxml">
          <i class="el-icon-upload"/>
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
          <div slot="tip" class="el-upload__tip">只能上传.jrxml文件</div>
        </el-upload>
      </el-form-item>
      <div class="title">模板参数</div>
      <el-table
          :data="template.items"
          :header-row-style="{'height': '40px'}"
          max-height="370px"
          border
          style="width: 100%; margin-top: 10px">
        <el-table-column
            type="index"
            align="center"
            label="序号"
            width="50px"/>
        <el-table-column
            prop="key"
            align="center"
            label="参数名">
          <template v-slot="scope">
            <el-input v-model.trim="scope.row.key"/>
          </template>
        </el-table-column>
        <el-table-column
            prop="desc"
            align="center"
            label="参数描述">
          <template v-slot="scope">
            <el-input v-model.trim="scope.row.desc"/>
          </template>
        </el-table-column>
        <el-table-column
            prop="value"
            align="center"
            label="默认值">
          <template v-slot="scope">
            <el-input v-model.trim="scope.row.value"/>
          </template>
        </el-table-column>
        <el-table-column
            prop="hidden"
            align="center"
            label="是否隐藏"
            width="100px">
          <template v-slot="scope">
            <el-switch
                v-model="scope.row.hidden"
                :active-value="true"
                :inactive-value="false"
                active-text="是"
                inactive-text="否"/>
          </template>
        </el-table-column>
        <el-table-column
            align="center"
            fixed="right"
            width="80px">
          <template #header>
            <el-button type="text" @click="handleRowAdd">+ 新增行</el-button>
          </template>
          <template v-slot="scope">
            <el-button type="text" @click="handleRowDelete(scope.$index)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-form>
    <div slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="handleSubmit">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>

  import axios from "axios";

  export default {
    name: "MaterialLabelPrintTemplateEdit",
    components: {},
    data() {
      return {
        dialogVisible: false,
        contentLoading: false,
        downLoadLoading: false,
        submitLoading: false,
        typeLoading: false,
        uploadAuth: 740,
        templateTypes: [],
        template: {
          id: null,
          name: "",
          typeId: null,
          typeName: "",
          note: "",
          items: [],
          attachment: null,
        },
      };
    },
    methods: {
      open(id) {
        this.dialogVisible = true;
        this.getTemplateTypes();
        if (id > 0) {
          this.template.id = id;
          this.getData();
        }
      },
      getData() {
        this.contentLoading = true;
        this.$http
          .get("basic", `materialLabelPrints/template/${this.template.id}`)
          .then(resp => {
            this.template = resp.data;
          })
          .finally(() => {
            this.contentLoading = false;
          });
      },
      getTemplateTypes() {
        this.typeLoading = true;
        this.$http
          .get("basic", "materialLabelPrints/list/template/type/all")
          .then((resp) => {
            this.templateTypes = resp.data || [];
          }).finally(() => {
            this.typeLoading = false;
          });
      },
      handleRowAdd() {
        let itemDetail = {
          key: "",
          desc: "",
          value: "",
          hidden: false,
        };
        this.template.items.push(itemDetail);
      },
      handleRowDelete(index) {
        this.template.items.splice(index, 1);
      },
      beforeUpload(file) {
        let fileName = file.name;
        let pos = fileName.lastIndexOf(".");
        let lastName = fileName.substring(pos, fileName.length);
        if (lastName.toLowerCase() !== ".jrxml") {
          this.$message.error("只能上传.jrxml文件");
          return false;
        }
        return true;
      },
      handleDownload() {
        this.downLoadLoading = true;
        this.$http.get("basic", `files/getDownloadUrl?key=${encodeURIComponent(this.template.attachment.filePath)}`).then((res) => {
          if (res.success) {
            window.open(res.data);
          }
        }).finally(() => {
          this.downLoadLoading = false;
        });
      },
      getVoucher(file) {
        this.$http.get("basic", `files/getUploadUrl?filename=${encodeURIComponent(file.file.name)}&authIndex=${this.uploadAuth}`).then((res) => {
          if (res.success) {
            axios({
              method: "PUT",
              headers: res.data.headers,
              url: res.data.url,
              data: file.file,
            }).then(() => {
              this.$message.success("上传成功");
              this.template.attachment = {
                fileName: file.file.name,
                filePath: res.data.key,
              };
            });
          }
        });
      },
      handleSuccess(file) {
        console.log(file);
      },
      handlerError(err) {
        alert(err);
      },
      handleFileDelete() {
        this.template.attachment = null;
      },
      handleSubmit() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .post("basic", "materialLabelPrints/template", this.template)
              .then(res => {
                if (res.success) {
                  this.submitLoading = false;
                  this.dialogVisible = false;
                  this.$emit("save-success");
                  this.$message.success("保存成功");
                }
              })
              .finally(() => {
                this.submitLoading = false;
              });
          }
        });
      },
    },
  };
</script>

<style scoped>
.title {
    border-bottom: 1px solid #ddd;
    margin-bottom: 5px;
    padding-bottom: 5px;
    color: #000;
    font-size: 14px;
    font-weight: 700;
}
</style>
